export default {
  id: 'ztmain',
  debug: false,
  app: 'orderadmin',
  title: 'Zaberi Tovar',
  domain: 'ztmain',
  localServer: 'zt.orderadmin.ru',
  defaultServer: 'https://panel.orderadmin.ru',
  securityLogo: 'assets/robot.png',
  logoSrc: 'assets/logos/logo.png',
  logoLeft: 'assets/logos/logo-nosign.png',
  logoTop: 'assets/logos/logo-nosign.png',
  theme: 'default',
  servers: [],
  locale: {
    name: 'English',
    locale: 'en',
    flag: 'us'
  },
  automaticCreatedEntities: {
    shippedbg: {
      sender: {},
      shop: {}
    }
  }
}
